import styled, { css } from 'styled-components';

// Variant -> CSS rules. Mirrors .prs-alert-{variant} from the Prose v1.5 spec.
// The `info` variant is also the unbranded default — when no variant is passed,
// PrsAlert falls through to `--prs-c-primary*` (the Prose default in the spec).
//
// Each variant declares the full `border` shorthand instead of only
// `border-color: currentColor`. The Prose source does the latter and lets the
// base `.prs-alert` rule supply the width — but if a global reset (e.g.
// `* { border: 0 solid … }`) wins over the base for any reason, color-only
// overrides leave the alert with width: 0 and no visible frame. Setting the
// shorthand here is self-contained and immune to that cascade.
const variantStyles = {
  info: css`
    border-color: currentColor;
    background-color: var(--prs-c-info-100);
    color: var(--prs-c-info-700);
  `,
  success: css`
    border-color: currentColor;
    background-color: var(--prs-c-success-100);
    color: var(--prs-c-success-800);
  `,
  warning: css`
    border-color: currentColor;
    background-color: var(--prs-c-warning-100);
    color: var(--prs-c-warning-900);
  `,
  danger: css`
    border-color: currentColor;
    background-color: var(--prs-c-danger-100);
    color: var(--prs-c-danger);
  `,
  neutral: css`
    border-color: currentColor;
    background-color: var(--prs-c-gray-100);
    color: var(--prs-c-gray);
  `,
};

export const PrsAlertRoot = styled.div`
  padding: 0.75rem;
  border: 1px solid var(--prs-c-primary);
  background-color: var(--prs-c-primary-100);
  color: var(--prs-c-primary);
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;

  ${({ $variant }) => ($variant && variantStyles[$variant]) || ''}

  ${({ $ghost }) => $ghost && css`
    border-color: transparent;
    border-radius: var(--prs-radius-alert);
  `}
`;

export const PrsAlertIcon = styled.span`
  width: 1.5rem;
  height: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 9999px;
  color: currentColor;
`;

export const PrsAlertContent = styled.div`
  color: var(--prs-c-gray-900);
  flex: 1 1 0%;
`;

export const PrsAlertClose = styled.button`
  width: 1.5rem;
  height: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 9999px;
  background: none;
  border: none;
  padding: 0;
  color: var(--prs-c-gray-600);
  cursor: pointer;
  transition-property: var(--prs-transition-property);
  transition-timing-function: var(--prs-transition-timing);
  transition-duration: var(--prs-transition-duration);

  &:hover,
  &:focus-visible {
    color: var(--prs-c-gray-950);
    outline: 2px solid currentColor;
    outline-offset: 1px;
  }
`;
